import { useCallback } from 'react';

import { useSession } from '~hooks/useSession';
import { convertToBackendId } from '~utils/ids';

import { sendEvent } from './sendEvent';

export const useSendEvent = <Extra extends { [key: string]: unknown }>(
	event: string,
	params?: { [key: string]: unknown },
	options?: {
		forceSendNoUser?: true;
		forceSendDemoUser?: true;
	}
): ((extra?: Extra) => void) => {
	const { userId, isDemoUser } = useSession();

	return useCallback(
		(extra) => {
			const bot_UserId = params?.bot_UserId ?? extra?.bot_UserId ?? null;
			const botId = bot_UserId
				? { bot_UserId: convertToBackendId(bot_UserId as string) }
				: {};
			const body = {
				...params,
				...extra,
				...botId,
				timestamp: (Date.now() / 1000) | 0,
			};

			if (
				!isDemoUser ||
				options?.forceSendNoUser ||
				options?.forceSendDemoUser
			) {
				void sendEvent({
					userId,
					event,
					body,
					forceSendNoUser: options?.forceSendNoUser,
					forceSendDemoUser: options?.forceSendDemoUser,
				});
			}
		},
		[userId, isDemoUser, event, params, options]
	);
};
